
import { mapState } from 'vuex'
export default {
    data: () => ({
        wallet: 1,
        isOpenOverlay: false,
    }),
    computed: {
        ...mapState({
            onHoldWallet: (state) => state.player.onHoldWallet,
            player: (state) => state.player.player,
        }),
    },
    watch: {
        isOpenOverlay(value) {
            this.isMenuOpenOverlay(value)
        },
    },
    methods: {
        formatWalletBalance(input) {
            const MAX_ALLOWED = 99999999999.0

            if (input == null || input === '' || !input) {
                return '0.00'
            }

            const cleanStr = String(input).replace(/[^0-9.-]/g, '')

            if (!/^-?(\d+\.?\d*|\.\d+)$/.test(cleanStr)) {
                return '0.00'
            }

            const num = parseFloat(cleanStr)
            if (isNaN(num)) {
                return '0.00'
            }

            if (num <= MAX_ALLOWED && num >= -MAX_ALLOWED) {
                return this.formatCurrencyJS(num)
            } else {
                const integerPart = Math.floor(Math.abs(num)).toString()

                const first11 = integerPart.substring(0, 11)

                const sign = num < 0 ? '-' : ''

                return (
                    sign +
                    this.formatCurrencyJS(Number(first11))?.toString() +
                    '...'
                )
            }
        },
    },
}
